import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const PromotionIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="22.001" height="22" viewBox="0 0 22.001 22">
		<g transform="translate(-40 -350)">
			<path
				d="M11,22a3.305,3.305,0,0,1-2.337-.963l-.8-.8a1.655,1.655,0,0,0-1.17-.483H5.56a3.316,3.316,0,0,1-3.312-3.312V15.308a1.66,1.66,0,0,0-.484-1.172l-.79-.789A3.316,3.316,0,0,1,.962,8.665l.8-.8a1.655,1.655,0,0,0,.483-1.17V5.562A3.317,3.317,0,0,1,5.56,2.248H6.691a1.644,1.644,0,0,0,1.17-.485L8.652.974A3.315,3.315,0,0,1,13.335.962l.8.8a1.647,1.647,0,0,0,1.169.483h1.131a3.317,3.317,0,0,1,3.312,3.313v1.13a1.66,1.66,0,0,0,.484,1.172l.79.79a3.311,3.311,0,0,1,.022,4.672c-.011.011-.021.023-.032.033l-.781.781a1.655,1.655,0,0,0-.483,1.17v1.13a3.316,3.316,0,0,1-3.312,3.312H15.308a1.655,1.655,0,0,0-1.17.484l-.791.79A3.3,3.3,0,0,1,11,22"
				transform="translate(40 350)"
				fill="#ffab39"
			/>
			<path
				d="M5.94,7.3a.99.99,0,0,1-.208-.31.929.929,0,0,1-.067-.374.939.939,0,0,1,.067-.375,1.314,1.314,0,0,1,.2-.3.974.974,0,0,1,1.06-.213.865.865,0,0,1,.318.206.987.987,0,0,1,0,1.36,1,1,0,0,1-.681.283A.984.984,0,0,1,5.94,7.3ZM.288,7.3a.965.965,0,0,1,0-1.362L5.942.281A.963.963,0,0,1,7.3,1.644L1.648,7.3a.963.963,0,0,1-1.36,0Zm0-5.652A.965.965,0,0,1,0,.963,1.006,1.006,0,0,1,.279.287.874.874,0,0,1,.611.073.942.942,0,0,1,1.645.286a1.009,1.009,0,0,1,.213.3.937.937,0,0,1-.218,1.058.94.94,0,0,1-.678.279A.994.994,0,0,1,.286,1.646Z"
				transform="translate(47.208 357.21)"
				fill="#6d703d"
			/>
		</g>
	</svg>
);
